var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dev-group"},[_c('h2',{staticClass:"group-title"},[_vm._v("SCSS Variables")]),_c('pre',[_vm._v(_vm._s(_vm.variables))])])}
var staticRenderFns = []

export { render, staticRenderFns }